module.exports = __webpack_public_path__ + "img/m_online_shopping_icon_02.8b7a3fb4.png";